// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"rollfront"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18.25 7H10C6.68629 7 4 9.68629 4 13C4 16.3137 6.68629 19 10 19L17.5 19M16 10.5L19.5 7L16 3.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RollfrontIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'rollfront',
    ref,
    icon: element,
  },
));

RollfrontIcon.displayName = 'RollfrontIcon';

export default RollfrontIcon;
